export class WeeklyTimePicker {
  monOpenTime: any;
  monCloseTime: any;
  tuesOpenTime: any;
  tuesCloseTime: any;
  wedOpenTime: any;
  wedCloseTime: any;
  thursOpenTime: any;
  thursCloseTime: any;
  friOpenTime: any;
  friCloseTime: any;
  satOpenTime: any;
  satCloseTime: any;
  sunOpenTime: any;
  sunCloseTime: any;
}
